import { ResponseError } from '../../../config/api';
import { useSWR, responseInterface } from '../../../config/overrides/swr';
import API, { CUSTOM_PAGE, EVENT, PROTECTED, MeetingSlotsResponse } from '../../../lib/api';
import { useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';

const { fetchMeetingSlots } = API[PROTECTED];

export function useMeetingSlots(customPageId?: number): responseInterface<MeetingSlotsResponse, ResponseError> {
  const eventSettings = useEventSettings();
  const eventId = eventSettings?.eventId ? String(eventSettings.eventId) : null;
  const pageId = customPageId ? String(customPageId) : null;

  const keyFn = () => (eventId && pageId ? [EVENT, eventId, CUSTOM_PAGE, pageId, 'bookable'] : null);

  return useSWR(keyFn, fetchMeetingSlots);
}
